// 日本語 (ja)

export const ja = {
  brand: {
    name: 'DoneLine',
    tagline: '個人向けプロジェクト管理ツール',
  },
  common: {
    save: '保存',
    cancel: 'キャンセル',
    confirm: '確認',
    delete: '削除',
    rename: '名前を変更',
    archive: 'アーカイブ',
    add: '追加',
    close: '閉じる',
    edit: '編集',
    new: '新規',
    yes: 'はい',
    no: 'いいえ',
    back: '戻る',
    next: '次へ',
    skip: 'スキップ',
    done: '完了',
    loading: '読み込み中…',
    sending: '送信中…',
    saving: '保存中…',
    untitled: '無題',
    today: '今日',
    tomorrow: '明日',
    yesterday: '昨日',
    none: 'なし',
    optional: '任意',
    requiredField: '必須',
    confirmDelete: '削除しますか？',
  },
  nav: {
    today: '今日',
    upcoming: '近日',
    inbox: '受信箱',
    projects: 'マイプロジェクト',
    tags: 'タグ',
    reports: '週次レポート',
    settings: '設定',
    quickCapture: 'クイック追加',
    search: '検索',
    newProject: '新規プロジェクト',
    addSection: 'セクションを追加',
    menu: 'メニュー',
    openMenu: 'メニューを開く',
  },
  search: {
    title: '検索',
    placeholder: 'タスク・プロジェクト・タグを検索…',
    noResults: '結果がありません',
    tasks: 'タスク',
    projects: 'プロジェクト',
    tags: 'タグ',
  },
  today: {
    title: '今日',
    eyebrow: '今日',
    overdue: '期限切れ',
    today: '今日',
    completed: '完了済み',
    empty: '今日の予定はありません。一息ついてください ☕',
    summary: '{active} 進行中 · {done} 完了',
    reschedule: '再設定',
    rescheduled: '{count} 件を再設定しました',
  },
  inbox: {
    title: '受信箱',
    eyebrow: '受信箱',
    empty: '受信箱は空です。',
    pending: '未処理 {count} 件',
  },
  upcoming: {
    title: '近日',
    eyebrow: '7 日以内',
    todayLabel: '今日',
    tomorrowLabel: '明日',
    empty: '今後 7 日間にタスクはありません。',
  },
  project: {
    eyebrow: 'プロジェクト',
    notFound: 'プロジェクトが見つかりません',
    notFoundHint: '削除されたかアーカイブされている可能性があります。',
    inProgress: '進行中 {count} 件',
    completed: '完了 {count} 件',
    ungrouped: '未分類',
    addSection: 'セクションを追加',
    listView: 'リスト',
    ganttView: 'ガントチャート',
    ganttZoomIn: '拡大',
    ganttZoomOut: '縮小',
    ganttWide: 'ワイド',
    ganttCompact: '標準幅に戻す',
    empty: 'まだタスクがありません',
    emptyHint: '上の入力欄から追加してください。',
    sectionEmpty: '— タスクなし —',
    completedSection: '完了済み',
    newSectionTitle: '新しいセクション',
    newSectionPlaceholder: 'セクション名',
    renameProjectTitle: 'プロジェクト名を変更',
    renameProjectPlaceholder: 'プロジェクト名',
    editProjectTitle: 'プロジェクトを編集',
    color: '色',
    icon: 'アイコン',
    noIcon: 'アイコンなし',
    deleteProjectTitle: 'プロジェクト「{name}」を削除しますか？',
    deleteProjectDesc: 'このプロジェクトのタスクは受信箱に移動します。元に戻せません。',
    archiveProject: 'アーカイブ',
    actionsMenu: 'プロジェクト操作',
    renameSectionTitle: 'セクション名を変更',
    sectionDeleteTitle: 'セクション「{name}」を削除しますか？',
    sectionDeleteDesc:
      'このセクションのタスクはプロジェクト直下に移動します。この操作は取り消せません。',
    sectionActionsMenu: 'セクションの操作',
    sectionReorder: 'セクションを並べ替え',
    descriptionPlaceholder: 'このプロジェクトについてメモを追加…',
    descriptionEditHint: 'Markdown 対応 · ⌘↵ 保存 · Esc 閉じる',
    descriptionEmpty: 'クリックしてメモを追加',
  },
  upgrade: {
    title: 'DoneLine Pro にアップグレード',
    featureLocked: '「{feature}」は Pro 機能です。',
    comingSoon: 'Pro はまもなく開始します。準備ができたらアカウントは自動で利用可能になります。',
    signInFirst: 'サインインしてアップグレード',
    benefits: {
      unlimitedProjects: 'プロジェクト数無制限（無料は 3 つまで）',
      history: '365 日間の編集履歴（無料は 7 日）',
      gantt: 'ガントチャート表示',
      importExport: 'データのインポート / エクスポート',
      themes: 'Paper を含む追加テーマ',
    },
    feature: {
      projects: '4 つ目以降のプロジェクト',
      gantt: 'ガントチャート',
      importExport: 'インポート / エクスポート',
      paperTheme: 'Pro テーマ',
    },
    cta: {
      stripe: '購読 — 月額 $2.99 / 年額 $29.99',
      apple: 'Apple で購読',
      google: 'Google Play で購読',
    },
  },
  plan: {
    title: 'プラン',
    description: '現在の購読プラン。',
    free: '無料',
    pro: 'Pro',
    proAi: 'Pro AI',
    upgradeButton: 'Pro にアップグレード',
    devSwitchHint: 'プレビュー：プランを切り替えて挙動を確認',
    switchToFree: '無料に切り替え（プレビュー）',
    switchToPro: 'Pro に切り替え（プレビュー）',
  },
  reports: {
    eyebrow: '週次レポート',
    title: '過去 7 日間の振り返り',
    serverGeneratedAt: 'サーバー生成: {time}',
    syncingFromServer: 'サーバーと同期中…',
    computedLocally: 'ローカル計算',
    aiSummary: 'AI 週次サマリー',
    completedCount: '完了数',
    completionRate: '完了率',
    overdueCount: '期限超過',
    dailyAverage: '1 日平均',
    dailyCompleted: '日別完了数',
    dailyCompletedAxis: '（タスク数）',
    byProject: 'プロジェクト別',
    noCompletedThisWeek: '今週はまだ完了したタスクがありません。',
    serverNotReady:
      'サーバーは今週のレポートをまだ生成していません。毎週月曜 09:00（あなたのタイムゾーン）に batch worker が自動生成します。',
  },
  settings: {
    display: {
      title: '表示',
      description: 'タスク一覧に行内で表示する項目を選べます。',
      tags: 'タグ',
      tagsHint: 'タスク行にタグを表示',
      descriptionLabel: '説明',
      descriptionHint: '説明を1行プレビュー表示',
      subtasks: 'サブタスク',
      subtasksHint: 'サブタスクの進捗と展開を表示',
    },
    eyebrow: '設定',
    title: '環境設定',
    appearance: { title: '外観', description: 'シーンに合うテーマを選びます。' },
    language: { title: '言語', description: 'メニューやラベルの表示言語。' },
    desktop: {
      title: 'デスクトップ',
      description:
        'ネイティブ macOS / Windows / Linux 向けの挙動。デスクトップアプリでのみ有効です。',
      alwaysOnTopLabel: '常に最前面',
      alwaysOnTopHint: 'オフにするまで他のアプリの上にウィンドウを固定します。',
      globalHotkeyLabel: 'グローバルクイックキャプチャショートカット',
      globalHotkeyHint:
        'システム全体 ⌘⇧Space — どこからでも DoneLine を呼び出してキャプチャ欄にフォーカスします。',
    },
    account: {
      title: 'アカウント',
      description: 'サインイン情報と概要。',
      summary: 'タスク {tasks} 件 · プロジェクト {projects} 件',
      signOut: 'ログアウト',
      deleteAccount: 'アカウントを削除',
      deleteAccountConfirmTitle: 'アカウントを削除しますか？',
      deleteAccountConfirmBody:
        'アカウントと、サーバーおよびこのブラウザにあるすべてのタスク・プロジェクト・タグを完全に削除します。取り消せません。データを残したい場合は先にエクスポートしてください。',
      deleteAccountConfirm: '削除',
      deleteAccountFailed: 'アカウントを削除できませんでした',
      signingOut: 'ログアウト中…',
      notSignedIn: '未ログイン',
      signInCta: 'サインイン',
      guestHint:
        'ゲストモード：データは本端末のみ。サインインで同期とバックアップが有効になります。',
      displayNameLabel: '表示名',
      displayNamePlaceholder: 'あなたの名前',
      displayNameSaved: '保存しました',
      displayNameSaveFailed: '保存に失敗しました',
      avatarLabel: 'アバター',
      avatarHint: 'JPG / PNG / WEBP / GIF（最大 2 MB）。未設定の場合はイニシャル表示。',
      avatarUpload: '画像をアップロード',
      avatarChange: '画像を変更',
      avatarUploading: 'アップロード中…',
      avatarRemove: '削除',
      avatarSaved: 'アバターを更新しました',
      avatarSaveFailed: 'アバターの更新に失敗しました',
      avatarErrorType: '対応していない画像形式です。JPG / PNG / WEBP / GIF を使用してください。',
      avatarErrorSize: '画像が大きすぎます。最大 2 MB。',
    },
    sync: {
      title: '同期',
      description: 'サーバーと完全な増分同期を実行。',
      forceSync: '今すぐ強制同期',
      syncing: '同期中…',
      done: '同期完了',
    },
    shortcuts: {
      title: 'キーボードショートカット',
      description: 'キーボードは最速のポインタ。',
      view: 'ショートカットを見る',
    },
    data: {
      title: 'データ',
      description: 'すべてのデータはローカル優先で保存され、サーバーへ同期されます。',
      export: 'JSON エクスポート',
      import: 'JSON インポート',
      exportDone: '{n} 件のタスクをエクスポートしました',
      importDone: '新しい {n} 件をインポートしました',
      importError: 'インポート失敗: {error}',
      importPersistFailed:
        'インポートをローカルストレージに保存できませんでした。データが端末の保存容量の上限を超えている可能性があります。数回に分けてインポートしてください。',
      clearAll: 'ローカルデータをクリア',
      clearConfirmTitle: 'すべてのローカルデータを削除しますか？',
      clearConfirmDesc:
        'このブラウザに保存された内容を削除します。サーバー上の同期データには影響しません。完了後にページが再読み込みされます。',
      cleared: 'クリア完了。再読み込み中…',
    },
    about: {
      title: 'このアプリについて',
      version: 'バージョン {v}',
      description: 'GTD ベースの個人 todo & プロジェクト管理ツール。',
    },
  },
  guest: {
    banner:
      'ゲストモード — データはこの端末のみに保存されます。サインインすると複数端末で同期できます。',
    bannerCta: 'サインイン',
    emptyHint:
      'ログインするまでデータはこの端末にのみ保存されます。まずは下から最初のタスクを追加しましょう。',
    storageWarning:
      'ゲストデータはこのブラウザにのみ保存され、システムに削除される場合があります。サインインまたはエクスポートで保護してください（エクスポートは暗号化されません）。',
  },
  login: {
    welcomeBack: 'おかえりなさい',
    helperSupabase: 'メールアドレスを入力すると、ワンタイムサインインリンクを送ります。',
    helperLocal:
      'ローカルモード：メールアドレスを入力すると即時サインインします（Supabase 未設定時のフォールバック）。',
    emailPlaceholder: 'you@example.com',
    sendLink: 'サインインリンクを送信',
    sendingLink: '送信中…',
    sentSupabase: '{email} に送信しました。受信箱のリンクをクリックしてください。',
    otpPrompt: 'またはメール内の確認コードを入力',
    otpPlaceholder: '6 桁のコード',
    otpSubmit: 'ログイン',
    otpFailed: 'コードが無効か、有効期限が切れています',
    sentLocal: '{email} としてサインインしました。読み込み中…',
    modeSupabase: 'Supabase Auth',
    modeLocal: 'ローカル Mock モード（バックエンド未設定時）',
    skipGuest: 'スキップして今すぐ使う',
    skipFailed:
      'ゲストモードを開始できませんでした（ローカル保存に失敗）。もう一度お試しください。',
    merge: {
      title: 'この端末に {count} 件のタスクがあります',
      keep: 'アカウントに統合する',
      irreversible: 'サインイン後にアップロードされます。統合後は元に戻せません。',
      discard: 'ローカルデータを残さずサインイン',
      discardConfirmTitle: 'サインイン後に {count} 件のローカルタスクを削除します',
      discardConfirmBody:
        'サインイン完了後、この端末の {count} 件のタスクは完全に削除され、復元できません。続行しますか？',
    },
    error: 'サインイン失敗',
  },
  task: {
    recurringAdvanced: '繰り返しタスクを {date} に更新しました',
    recurringFinished: '繰り返しが終了し、タスクを完了しました',
    titlePlaceholder: 'タスク名',
    description: '説明',
    descriptionPlaceholder: '説明を追加…',
    descriptionEmpty: '説明はまだありません。',
    descriptionEdit: '説明を編集',
    descriptionSave: '説明を保存',
    descriptionCancel: 'キャンセル',
    save: '保存',
    saved: '保存しました',
    discardConfirmTitle: '未保存の変更を破棄しますか？',
    discardConfirmDesc: '未保存の編集があります。今閉じると失われます。',
    priority: '優先度',
    date: '日付',
    project: 'プロジェクト',
    section: 'セクション',
    parentTask: '親タスク',
    tags: 'タグ',
    subtasks: 'サブタスク',
    expandSubtasks: 'サブタスクを展開',
    collapseSubtasks: 'サブタスクを折りたたむ',
    addSubtaskPlaceholder: '+ サブタスクを追加',
    comments: 'コメント',
    noComments: 'コメントはまだありません',
    commentPlaceholder: 'コメントを書く…',
    sendComment: '送信',
    delete: '削除',
    deleteConfirmTitle: 'このタスクを削除しますか？',
    deleteConfirmDesc: 'サブタスクも一緒に削除されます。',
    saveHint: '⌘/Ctrl + Enter で保存して閉じる',
    open: '開く',
    completed: '完了',
    markComplete: '完了にする',
    markIncomplete: '未完了に戻す',
    moreActions: 'その他の操作',
  },
  priority: {
    high: '高',
    mid: '中',
    low: '低',
    none: 'なし',
    p1: 'P1',
    p2: 'P2',
    p3: 'P3',
    p4: 'P4',
  },
  date: {
    picker: {
      single: '日付',
      datetime: '時刻',
      range: '期間',
      today: '今日',
      tomorrow: '明日',
      thisWeekend: '今週末',
      nextWeek: '来週',
      noDate: '日付なし',
    },
    overdue: '期限超過',
    notScheduled: '日付未設定',
  },
  recurrence: {
    title: '繰り返し',
    none: '繰り返さない',
    custom: 'カスタム…',
    applyCustom: 'カスタムルールを適用',
    end: '繰り返しを終了',
    preset: {
      daily: '毎日',
      weekdays: '平日',
      weekly: '毎週',
      biweekly: '2週ごと',
      monthly: '毎月',
      yearly: '毎年',
    },
    summary: {
      daily: '毎日',
      everyNDays: '{n} 日ごと',
      weekly: '毎週',
      everyNWeeks: '{n} 週ごと',
      weeklyOn: '毎週 {days}',
      everyNWeeksOn: '{n} 週ごと {days}',
      monthly: '毎月',
      everyNMonths: '{n} か月ごと',
      yearly: '毎年',
      everyNYears: '{n} 年ごと',
    },
    weekday: { sun: '日', mon: '月', tue: '火', wed: '水', thu: '木', fri: '金', sat: '土' },
    // ja は「N日ごと」の語順 ——「ごと」は後置助詞。UI の <span>every</span><input>N<select>freq>
    // という英語の Every→N→Unit 並びに合わせるため、every は空、ごとは freq の各単位に付ける。
    freq: { daily: '日ごと', weekly: '週ごと', monthly: 'か月ごと', yearly: '年ごと' },
    every: '',
  },
  aiUsage: {
    title: 'AI使用状況',
    planFree: '無料プラン',
    planPro: 'Proプラン',
    planProAi: 'Pro AIプラン',
    usedOf: '今月 {used} / {limit} 回',
    remaining: '残り {count} 回',
    resetsMonthly: '毎月1日（UTC）にリセット',
    history: '最近の利用',
    historyEmpty: 'まだ利用履歴がありません',
    endpointParse: 'AI解析',
    endpointBreakdown: 'AI分解',
    signInFirst: 'ログインすると確認できます',
    loadFailed: '読み込みに失敗しました',
    retry: '再試行',
  },
  parseTask: {
    mode: 'AI',
    quickMode: 'クイック',
    title: 'AI タスク解析',
    placeholder: 'タスクを自由に入力…',
    titlePlaceholder: 'タスク名',
    hint: 'AI が日付・優先度・プロジェクト・タグを自動入力',
    parse: '解析',
    confirm: 'タスクを追加',
    confirmMany: '{count}件のタスクを追加',
    back: '戻る',
    voice: '音声入力',
    voiceDenied: 'マイクの許可が拒否されました',
    voiceUnavailable: 'このブラウザは音声入力に対応していません',
    errors: {
      rateLimited: 'リクエストが多すぎます。しばらくしてからお試しください',
      monthlyLimit: '今月のAI利用回数を使い切りました。アップグレードで追加できます',
      unauthorized: 'AI を使うにはサインインしてください',
      unavailable: 'AI は現在利用できません',
      failed: 'タスクを解析できませんでした。言い換えてお試しください',
    },
  },
  quickCapture: {
    placeholder: 'タスクを追加…（Enter で保存）',
    hint: '例:「買い物 tomorrow @生活 #クイック p2」',
    newTag: '#{name}（新規）',
    dismissMatch: '「{label}」をテキストのまま残す',
    createTag: 'タグ「{name}」を作成',
    syntaxCheatsheet: 'today / tomorrow / next mon · @プロジェクト[/セクション] · #タグ · p1-p4',
    add: '追加',
    open: 'クイック追加を開く',
    addTask: 'タスクを追加',
  },
  tag: {
    eyebrow: 'タグ',
    editTagTitle: 'タグを編集',
    renameTagPlaceholder: 'タグ名',
    newTagPlaceholder: '新しいタグ…',
    deleteTagTitle: 'タグ「{name}」を削除しますか？',
    deleteTagDesc: '{count} 件のタスクからこのタグが外れます。元に戻せません。',
    actionsMenu: 'タグ操作',
    nameTaken: '同名のタグが既にあります',
    empty: 'このタグの付いたタスクはありません',
  },
  quickbar: {
    signInRequired: 'サインインが必要です',
    signInHint: 'メニューバーからタスクを追加するにはサインインしてください。',
    signInOpenMain: 'DoneLine のメインウィンドウを開いてサインインしてください',
  },
  sync: {
    idle: '同期済み',
    syncing: '同期中',
    offline: 'オフライン',
    error: '同期失敗',
    disabled: 'ローカルモード',
    pending: '未同期 {count} 件',
    syncingPending: '同期中 · 未同期 {count} 件',
    offlinePending: 'オフライン · 未同期 {count} 件',
    authError: '認証失敗 — 再度サインインしてください',
    rejectedBatch: 'データ検証に失敗 — 一部の変更が破棄されました',
    retry: 'クリックで再試行',
  },
  commandPalette: {
    placeholder: 'タスク検索、ビュー移動、コマンド実行…',
    empty: '一致するものがありません。',
    tasks: 'タスク',
    projects: 'プロジェクト',
    navigation: 'ナビゲーション',
    actions: 'アクション',
  },
  bulk: {
    toolbar: '一括操作',
    selected: '{count} 件選択中',
    clear: '選択解除',
    deleteTitle: '選択した {count} 件を削除しますか？',
    deleteDesc: 'サブタスクも一緒に削除されます。元に戻せません。',
    mixedProjects: '複数のプロジェクト',
  },
  shortcuts: {
    title: 'キーボードショートカット',
    quickAdd: 'クイック追加',
    search: '検索',
    help: 'このパネルを表示',
    gotoToday: '今日へ',
    gotoInbox: '受信箱へ',
    gotoUpcoming: '近日へ',
    drawer: {
      title: 'タスク詳細内',
      saveClose: '保存して閉じる',
      delete: 'タスクを削除',
      priorityKeys: '優先度を設定（1=高 … 4=なし）',
    },
  },
  welcome: {
    title: '{brand} へようこそ',
    subtitle: '30 秒で使い始めましょう。',
    step1: {
      title: '1 秒であらゆることをキャプチャ',
      body: '任意のページで Q キーを押すとクイック追加が開きます。タスクを入力して Enter で受信箱へ。',
    },
    step2: {
      title: '余裕がある時に整理',
      body: 'タスクをプロジェクトとセクションへドラッグ。日付・優先度・タグは後から追加できます。',
    },
    step3: {
      title: '今日を計画',
      body: '今日ビューは今日が期限のタスクと、今日を含む期間タスクを自動的に集約します。',
    },
    step4: {
      title: '準備完了',
      body: '操作に慣れるためのスタートタスクをいくつか用意しました。完了にしても削除しても構いません。',
    },
    getStarted: '始める',
  },
  onboarding: {
    project: { welcome: 'ようこそ', learn: '使い方' },
    tasks: {
      welcome: '👋 {brand} へようこそ！',
      welcomeDesc:
        '左側のチェックボックスをクリックして完了にしてみましょう。これがタスク完了の操作です。',
      quickAdd: '⚡ クイック追加を試す: Q キーまたは左上のボタン',
      quickAddDesc:
        'タスク名を入力して Enter。@プロジェクト名 でプロジェクト指定、#タグ名 でタグ付け、p1-p4 で優先度設定。',
      organize: '📁 関連タスクをプロジェクトにまとめる',
      organizeDesc: '左側の「+ 新規プロジェクト」をクリック。タスクをドラッグして整理。',
      schedule: '🗓 日付を設定して計画',
      scheduleDesc:
        '今日のタスクは自動で「今日」ビューに表示されます。このタスクを開いて期限を設定してみましょう。',
      priority: '🔥 優先度を活用 (P1 高 … P4 なし)',
      priorityDesc: 'タスク詳細で 1 / 2 / 3 / 4 を押すと優先度を素早く切り替え。',
      drag: '✋ ドラッグで並べ替え',
      dragDesc: 'タスクにマウスを乗せると左にハンドルが出ます。掴んで好きな位置へ。',
      gantt: '📊 ガントチャートで可視化',
      ganttDesc:
        'プロジェクトを開いて「ガントチャート」タブに切り替えると、時間軸上でタスクを確認できます。',
      reports: '📈 週次レポートで振り返り',
      reportsDesc: '毎週、何を完了したか、何が持ち越されたかを確認しましょう。',
      finishMe: '✅ このリストを完了 — 準備完了です！',
    },
  },
  errors: {
    networkError: 'ネットワークエラー',
    unknownError: '不明なエラー',
    notFound: '見つかりません',
    pageNotFound: 'ページが見つかりません',
    pageNotFoundDesc: 'この URL は存在しないか、移動されました。',
    backHome: '今日に戻る',
    somethingWrong: 'エラーが発生しました',
    tryAgain: 'もう一度',
    goHome: 'ホームへ',
  },
  theme: {
    light: 'ライト',
    dark: 'ダーク',
    paper: 'ペーパー',
    rose: 'ローズ',
    lavender: 'ラベンダー',
    peach: 'ピーチ',
    mauve: 'モーヴ',
    slate: 'スレート',
    forest: 'フォレスト',
    midnight: 'ミッドナイト',
    shiba: '柴犬',
    cat: 'ねこ',
    ocean: 'オーシャン',
    sky: 'スカイ',
    mint: 'ミント',
    matcha: '抹茶',
    amber: 'アンバー',
    mocha: 'モカ',
    crimson: 'クリムゾン',
    nord: 'ノルド',
    dracula: 'ドラキュラ',
    graphite: 'グラファイト',
    system: 'システム',
    pickerTitle: 'テーマ',
  },
} as const;
